var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "documentsListContainer", staticClass: "container mb-5" },
    [
      _c("div", { staticClass: "k-tabs" }, [
        _c("div", { staticClass: "k-tabs__sorting" }, [
          _c("span", { staticClass: "k-tabs__sorting-text" }, [
            _vm._v("Filtrovat podle:")
          ]),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.filterBy,
                  expression: "filterBy"
                }
              ],
              ref: "filterSelect1",
              staticClass: "form-control",
              on: {
                change: [
                  function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.filterBy = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                  _vm.filterChanged
                ]
              }
            },
            [
              _c(
                "option",
                { attrs: { disabled: "", value: "", placeholder: "" } },
                [_vm._v("Vyberte")]
              ),
              _vm._v(" "),
              _c("option", { attrs: { value: "information_type" } }, [
                _vm._v("Typu informace")
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "category" } }, [
                _vm._v("Kategorie")
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "subcategory" } }, [
                _vm._v("Podkategorie")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.filterBy.length > 0,
                  expression: "filterBy.length > 0"
                }
              ],
              staticClass: "k-custom-width"
            },
            [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.filterByOption,
                      expression: "filterByOption"
                    }
                  ],
                  ref: "filterSelect2",
                  staticClass: "form-control",
                  on: {
                    change: [
                      function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.filterByOption = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                      _vm.filterSelected
                    ]
                  }
                },
                [
                  _c(
                    "option",
                    { attrs: { disabled: "", value: "", placeholder: "" } },
                    [_vm._v("Vyberte")]
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _vm.is_remove_filters_btn_visible
            ? _c(
                "a",
                {
                  staticClass: "k-action k-action--control-danger",
                  attrs: { href: "javascript:;" },
                  on: { click: _vm.resetFilters }
                },
                [_vm._v("\n                Zrušit\n            ")]
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "k-tabs__sorting" }, [
          _c("span", { staticClass: "k-tabs__sorting-text" }, [
            _vm._v("Řadit podle:")
          ]),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.orderBy,
                  expression: "orderBy"
                }
              ],
              ref: "sortSelect1",
              staticClass: "form-control",
              on: {
                change: [
                  function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.orderBy = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                  _vm.sortChanged
                ]
              }
            },
            [
              _c("option", { attrs: { value: "date" } }, [
                _vm._v("Data vložení")
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "downloads" } }, [
                _vm._v("Počtu stažení")
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "size" } }, [_vm._v("Velikosti")])
            ]
          ),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.orderDirection,
                  expression: "orderDirection"
                }
              ],
              ref: "sortSelect2",
              staticClass: "form-control",
              on: {
                change: [
                  function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.orderDirection = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                  _vm.sortChanged
                ]
              }
            },
            [
              _c("option", { attrs: { value: "asc" } }, [_vm._v("Vzestupně")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "desc" } }, [_vm._v("Sestupně")])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _vm.documents.data && _vm.documents.data.length > 0
        ? [
            _c(
              "div",
              { staticClass: "k-table k-table--doc-all" },
              [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "transition-group",
                  { attrs: { name: "list-complete", tag: "div" } },
                  _vm._l(_vm.documents.data, function(document) {
                    return _c(
                      "div",
                      { key: document.id, staticClass: "k-table__row" },
                      [
                        _c("div", { staticClass: "k-table__cell" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "k-file-meta k-file-meta--compact k-mr-20"
                            },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass: "k-file-meta__icon",
                                  attrs: {
                                    role: "img",
                                    width: "24",
                                    height: "25"
                                  }
                                },
                                [
                                  _c("use", {
                                    attrs: {
                                      fill: "currentColor",
                                      "xlink:href":
                                        "/images/spritesheet.svg#file-pdf"
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "k-file-meta__text" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(document.size_formatted) +
                                    "\n                            "
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "mr-auto" }, [
                            _c(
                              "a",
                              {
                                staticClass: "mb-1 d-block",
                                attrs: { href: document.detail_url }
                              },
                              [
                                _c("strong", { staticClass: "k-strong" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(document.title) +
                                      "\n                                "
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "k-table__cell-meta ml-0" },
                              _vm._l(document.categories, function(url, title) {
                                return _c(
                                  "a",
                                  {
                                    staticClass: "k-link mr-2",
                                    attrs: { href: url }
                                  },
                                  [_vm._v(_vm._s(title))]
                                )
                              }),
                              0
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "k-table__cell k-table__cell--type" },
                          [
                            _c("div", { staticClass: "k-table__cell-meta" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(document.information_type) +
                                  "\n                        "
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "k-table__cell k-table__cell--meta" },
                          [
                            _c("div", { staticClass: "k-table__cell-meta" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(document.user_name) +
                                  "\n                        "
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "k-table__cell k-table__cell--meta" },
                          [
                            _c("div", { staticClass: "k-table__cell-meta" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(document.created_at) +
                                  "\n                        "
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "k-table__cell k-table__cell--action k-border-left"
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "k-action k-action--control",
                                attrs: { href: document.detail_url }
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "k-action__icon",
                                    attrs: {
                                      role: "img",
                                      width: "15",
                                      height: "15"
                                    }
                                  },
                                  [
                                    _c("use", {
                                      attrs: {
                                        fill: "currentColor",
                                        "xlink:href":
                                          "/images/spritesheet.svg#eye"
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(
                                  "\n                            Zobrazit\n                        "
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  }),
                  0
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("pagination", {
              staticClass: "mt-5",
              attrs: { data: _vm.documents, limit: 2 },
              on: { "pagination-change-page": _vm.paginate }
            })
          ]
        : [
            _vm.documents.data && _vm.documents.data.length === 0
              ? _c("div", { staticClass: "k-table" }, [_vm._m(1)])
              : _vm._e()
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "k-table__header" }, [
      _c("div", { staticClass: "k-table__cell" }, [
        _vm._v("\n                    Název / Kategorie\n                ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "k-table__cell--type" }, [
        _vm._v("\n                    Typ\n                ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "k-table__cell k-table__cell--meta" }, [
        _vm._v("\n                    Autor\n                ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "k-table__cell k-table__cell--meta" }, [
        _vm._v("\n                    Datum\n                ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "k-table__row" }, [
      _c("div", { staticClass: "k-table__cell p-2 justify-content-center" }, [
        _vm._v(
          "\n                    Nebyly nalezeny žádné dokumenty.\n                "
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }